export default "__VITE_ASSET__BETkf3Ja__$_?nuxt_component=async&nuxt_component_name=SvgoAADF&nuxt_component_export=default__"